require('www/js/libs/magnific-popup/magnific-popup.css')
require('www/js/libs/magnific-popup/jquery.magnific-popup.min')

function initChooseTownDialog() {
  const chooseTownDialogButton = $('.b-choose-town-btn-v2')

  chooseTownDialogButton.on('click', () => {
    window.dispatchEvent(new CustomEvent('choose-town-dialog:open'))
  })
}

initChooseTownDialog()
